<template>
    <div>
        <ContactUsTop />
        <div class="JoinUsDetail">
            <div class="detailInfo">
                <div class="infoTop">
                    <div class="infoTopLeft">
                        <div class="topTitle">{{ info.name }}</div>
                        <div class="topDeatil">
                            {{ info.jobAddress }} | {{ info.education }} |
                            {{ info.peopleNum }}人
                        </div>
                    </div>
                    <a-button type="primary" v-show="false" size="large" @click="applyJob">申请职位</a-button>
                </div>
              <div class="infoMid" style="margin-bottom: 40px" v-show="info.contact">
                <div class="divide">
                  <div class="divideFont">[联系方式]</div>
                  <div class="divideLine"></div>
                </div>
                <div
                    class="midConent"
                >
                  {{ info.contact }}&nbsp;&nbsp;&nbsp;&nbsp;{{ info.contactTel }}<br><br>{{ info.contactEmail }}
                </div>
              </div>
                <div class="infoMid">
                    <div class="divide">
                        <div class="divideFont">[岗位要求]</div>
                        <div class="divideLine"></div>
                    </div>
                    <div
                        class="midConent"
                        v-for="(item, idx) in info.newPostRemarks"
                        :key="idx"
                    >
                        {{ item }}
                    </div>
                </div>
                <div class="infoBot">
                    <div class="divide">
                        <div class="divideFont">[任职要求]</div>
                        <div class="divideLine"></div>
                    </div>
                    <div
                        class="botConent"
                        v-for="(item, idx) in info.newJobRemarks"
                        :key="idx"
                    >
                        {{ item }}
                    </div>
                </div>
                <div class="infoAdd">
                    <div class="divide">
                        <div class="divideFont">[福利待遇]</div>
                        <div class="divideLine"></div>
                    </div>
                    <div class="addBoxStyle">
                        <div class="addStyle">{{info.welfare1}}</div>
                        <div class="addStyle">{{info.welfare2}}</div>
                        <div class="addStyle">{{info.welfare3}}</div>
                        <div class="addStyle">{{info.welfare4}}</div>
                        <div class="addStyle">{{info.welfare5}}</div>
                        <div class="addStyle">{{info.welfare6}}</div>
                        <div class="addStyle">{{info.welfare7}}</div>
                        <div class="addStyle">{{info.welfare8}}</div>
                    </div>
                </div>
                <div class="infoDomBot">
                    <a-button type="primary" size="large" @click="applyJob" v-show="false">申请职位</a-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ContactUsTop from "@/components/ContactUsTop.vue";
export default {
    name: "JoinUsDetail",
    components: {
        ContactUsTop,
    },
    data() {
        return {
            info: {},
        };
    },
    created() {
        if (this.$route.params.name) {
            this.info = this.$route.params;
            sessionStorage.setItem(
                "joinUsDetail",
                JSON.stringify(this.$route.params)
            );
        } else {
            let params = JSON.parse(sessionStorage.getItem("joinUsDetail"));
            this.info = params;
        }
    },
    methods: {
        applyJob(){
            this.$message.warning('敬请期待')
        }
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.divide {
    width: 100%;
    display: flex;
    align-items: center;
    .divideFont {
        min-width: 100px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin-right: 2rem;
    }
    .divideLine {
        width: 100%;
        border: dashed 1px #e1e1e1;
    }
}
.JoinUsDetail {
    padding-top: 90px;
    padding-bottom: 160px;
    background-color: #fbfbfb;
    .detailInfo {
        background: white;
        .typeArea();
        padding: 80px 50px 50px;
        .infoTop {
            margin-bottom: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .infoTopLeft {
                .topTitle {
                    font-family: "优设标题黑";
                    font-size: 36px;
                    color: #333333;
                    line-height: 28px;
                    margin-bottom: 20px;
                }
                .topDeatil {
                    line-height: 28px;
                    font-size: 16px;
                    color: #666666;
                }
            }
            .infoTopRight {
            }
        }
        .infoMid {
            .midConent {
                margin-top: 40px;
                padding: 0 28px;
                font-size: 16px;
                color: #666666;
            }
        }
        .infoBot {
            margin-top: 60px;
            .botConent {
                margin-top: 40px;
                padding: 0 28px;
                font-size: 16px;
                color: #666666;
            }
        }
        .infoAdd {
            margin-top: 60px;
            .addBoxStyle {
                margin-top: 50px;
                display: flex;
                flex-flow: wrap;
                .addStyle {
                    word-break: break-all;
                    padding: 0 10px;
                    margin-bottom: 40px;
                    width: 25%;
                    box-sizing: border-box;
                    font-size: 16px;
                    color: #666666;
                }
            }
        }
        .infoDomBot {
            margin-top: 72px;
            width: 100%;
            text-align: center;
        }
    }
}
</style>
